module.exports = __webpack_public_path__ + "static/img/W_FUR.0cd2acd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/W_FUR.jpg
// module id = 24rH
// module chunks = 1